import { jsx as c } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import g from "@mui/material/IconButton";
import m from "styled-components";
import "../../theme/themes/AtriusDark.js";
import "../../theme/themes/AtriusLight.js";
import "../../theme/themes/DistechDark.js";
import "../../theme/themes/DistechLight.js";
import "../../theme/themes/DLNLight.js";
import "../../theme/utils/getThemeDefinition.js";
import { getSize as e, getPadding as p, getFontSize as b, getColor as B, getBackground as f, getBorderColor as h, getIconSize as i, getColorHover as x, getBackgroundHover as k, getBorderColorHover as v, getColorPress as C, getBackgroundPress as y, getBorderColorPress as z, getColorDisabled as I, getBackgroundDisabled as R } from "../../theme/utils/styleUtils.js";
import "../../theme/GlobalStyle.js";
import "@emotion/is-prop-valid";
import "@mui/material/styles";
import "lodash/merge";
import "color-convert";
const w = {
  root: "iconButtonRoot",
  disabled: "iconButtonDisabled"
}, D = m(g).withConfig({
  displayName: "StyledIconButton"
})([
  "&&.iconButtonRoot{height:",
  ";width:",
  ";padding:",
  ";box-sizing:border-box;border-radius:",
  ";font-size:",
  ";line-height:1.2em;color:",
  ";background-color:",
  ";flex-direction:column;border:solid 1px ",
  ";svg{height:",
  ";width:",
  ";flex-shrink:0;}}&&.iconButtonRoot:hover{color:",
  ";background-color:",
  ";border:solid 1px ",
  ";}&&.iconButtonRoot.Mui-focusVisible{box-shadow:0 0 2px 2px ",
  ";}&&.iconButtonRoot:active{color:",
  ";background-color:",
  ";border:solid 1px ",
  ";}&&.iconButtonDisabled svg,&&.iconButtonDisabled{color:",
  ";background-color:",
  ";border:solid 1px transparent;}"
], ({ $size: o }) => e(o), ({ $autoWidth: o, $size: t }) => o ? "auto" : e(t), ({ $size: o }) => p(o), ({ $size: o }) => e(o), ({ $size: o }) => b(o), ({ $flavor: o, theme: t, $variant: r }) => B(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => f(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => h(t, r, o), ({ $size: o, $variant: t }) => i(o, t), ({ $size: o, $variant: t }) => i(o, t), ({ $flavor: o, theme: t, $variant: r }) => x(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => k(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => v(t, r, o), ({ theme: o }) => o.primaryFocus, ({ $flavor: o, theme: t, $variant: r }) => C(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => y(t, r, o), ({ $flavor: o, theme: t, $variant: r }) => z(t, r, o), ({ theme: o, $variant: t }) => I(o, t), ({ theme: o, $variant: t }) => R(o, t)), S = /* @__PURE__ */ u(({ children: o, classes: t, autoWidth: r = !1, flavor: n = "normal", size: d = "medium", variant: l = "outlined", ...s }, a) => /* @__PURE__ */ c(D, {
  ...s,
  ref: a,
  classes: {
    ...w,
    ...t
  },
  $autoWidth: r,
  $flavor: n,
  $size: d,
  $variant: l,
  children: o
}));
S.displayName = "IconButton";
export {
  S as default
};
